// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"7c046dd3","952":"c9ffa604"}[chunkId] + ".chunk.js";
};